import { SORT_OPTIONS } from "./constants";

export const getFilteredSortOptions = (isWithRecent: boolean) => {
  if (isWithRecent) {
    return SORT_OPTIONS
      .filter(option => option.value !== "new")
      .concat({ value: "recent", label: "Latest" });
  }

  return SORT_OPTIONS;
};
